var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunriseAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V5C11.25 5.41421 11.5858 5.75 12 5.75C12.4142 5.75 12.75 5.41421 12.75 5V3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8C9.49348 8 7.41774 9.84437 7.05588 12.25H2C1.58579 12.25 1.25 12.5858 1.25 13C1.25 13.4142 1.58579 13.75 2 13.75H22C22.4142 13.75 22.75 13.4142 22.75 13C22.75 12.5858 22.4142 12.25 22 12.25H16.9441C16.5823 9.84437 14.5065 8 12 8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 17C4.25 16.5858 4.58579 16.25 5 16.25H19C19.4142 16.25 19.75 16.5858 19.75 17C19.75 17.4142 19.4142 17.75 19 17.75H5C4.58579 17.75 4.25 17.4142 4.25 17Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20.25C7.58579 20.25 7.25 20.5858 7.25 21C7.25 21.4142 7.58579 21.75 8 21.75H16C16.4142 21.75 16.75 21.4142 16.75 21C16.75 20.5858 16.4142 20.25 16 20.25H8Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1264 7.8735C16.8335 7.58061 16.8335 7.10573 17.1264 6.81284L18.5406 5.39863C18.8335 5.10573 19.3084 5.10573 19.6013 5.39863C19.8942 5.69152 19.8942 6.16639 19.6013 6.45929L18.1871 7.8735C17.8942 8.16639 17.4193 8.16639 17.1264 7.8735Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87359 6.81284C7.16648 7.10573 7.16648 7.58061 6.87359 7.8735C6.5807 8.16639 6.10582 8.16639 5.81293 7.8735L4.39872 6.45929C4.10582 6.16639 4.10582 5.69152 4.39872 5.39863C4.69161 5.10573 5.16649 5.10573 5.45938 5.39863L6.87359 6.81284Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunriseAlt2);
export default __webpack_public_path__ + "static/media/sunrise-alt-2.41704208842b18ad5ff4cce41439718e.svg";
export { ForwardRef as ReactComponent };